(ns common.schema.entities.survey.timeseries
  (:require [common.dates :as c-date]
            [common.time :as c-time]))

(def historical-options
  [:last-3-months-quarterly
   :last-3-months-monthly
   :last-12-months-monthly
   :YTD-monthly
   :YTD-monthly-previous-year-quarterly
   :YTD-monthly-previous-year-monthly
   :previous-year-12-months-quarterly
   :last-12-months-quarterly
   :YTD-quarterly
   :YTD-quarterly-previous-year-quarterly
   :YTD-quarterly-previous-year-yearly
   :YTD-quarterly-previous-2-years-yearly
   :last-12-months-half-yearly
   :YTD-half-yearly
   :YTD-half-yearly-previous-year-half-yearly
   :YTD-half-yearly-previous-year-yearly
   :YTD-half-yearly-previous-2-years-yearly
   :YTD-yearly
   :YTD-yearly-previous-year-yearly
   :YTD-yearly-previous-2-years-yearly
   :custom-range-talk-to-support])

(defn monthly-columns
  [snapshot? ref-dt month-diff]
  (let [day-in-month (c-date/plus ref-dt (c-date/months month-diff))
        start-of-month (c-date/start-of-month day-in-month)
        end-of-month (c-date/end-of-month day-in-month)]
    {:start-ts (c-time/start-of-month-millis start-of-month)
     :end-ts   (c-time/end-of-month-millis end-of-month)
     :label    (str (when-not snapshot?
                      (c-date/format start-of-month {:pattern "dd.MM"}))
                    (when-not snapshot?
                      " - ")
                    (c-date/format end-of-month {:pattern "dd.MM.yyyy"}))}))

(defn quarterly-columns
  [snapshot? ref-dt month-diff]
  (let [day-in-month (c-date/plus ref-dt (c-date/months month-diff))
        start-of-month (c-date/start-of-month day-in-month)
        start-of-q-ms (c-time/start-of-q-millis start-of-month)
        end-of-month (c-date/end-of-month day-in-month)
        end-of-q-ms (c-time/end-of-q-millis end-of-month)]
    {:start-ts start-of-q-ms
     :end-ts   end-of-q-ms
     :label    (str (when-not snapshot?
                      (c-date/format (c-date/date-time start-of-q-ms) {:pattern "dd.MM"}))
                    (when-not snapshot?
                      " - ")
                    (c-date/format (c-date/date-time end-of-q-ms) {:pattern "dd.MM.yyyy"}))}))

(defn half-yearly-columns
  [snapshot? ref-dt month-diff]
  (let [day-in-month (c-date/plus ref-dt (c-date/months month-diff))
        start-of-month (c-date/start-of-month day-in-month)
        start-of-h-ms (c-time/start-of-h-millis start-of-month)
        end-of-month (c-date/end-of-month day-in-month)
        end-of-h-ms (c-time/end-of-h-millis end-of-month)]
    {:start-ts start-of-h-ms
     :end-ts   end-of-h-ms
     :label    (str (when-not snapshot?
                      (c-date/format (c-date/date-time start-of-h-ms) {:pattern "dd.MM"}))
                    (when-not snapshot?
                      " - ")
                    (c-date/format (c-date/date-time end-of-h-ms) {:pattern "dd.MM.yyyy"}))}))

(defn yearly-columns
  [snapshot? ref-dt month-diff]
  (let [day-in-month (c-date/plus ref-dt (c-date/months month-diff))
        start-of-year (c-date/start-of-year day-in-month)
        start-of-year-ms (c-time/start-of-q-millis start-of-year)
        end-of-year (c-date/end-of-year day-in-month)
        end-of-year-ms (c-time/end-of-q-millis end-of-year)]
    {:start-ts start-of-year-ms
     :end-ts   end-of-year-ms
     :label    (str (when-not snapshot?
                      (c-date/format (c-date/date-time start-of-year-ms) {:pattern "dd.MM"}))
                    (when-not snapshot?
                      " - ")
                    (c-date/format (c-date/date-time end-of-year-ms) {:pattern "dd.MM.yyyy"}))}))

(defn history-columns
  [{:keys [history snapshot-history? _forecast _forecast-in-use? reference-period]}]
  (let [{:keys [start-ts end-ts]} reference-period
        _start-dt (c-date/date-time start-ts)
        end-dt (c-date/date-time end-ts)
        end-month (c-date/get-month end-dt)]
    (case history
      :last-3-months-quarterly (->> (range -2 1)
                                    (mapv (partial quarterly-columns snapshot-history? end-dt))
                                    (distinct)
                                    (sort-by :start-ts))
      :last-3-months-monthly (->> (range -2 1)
                                  (mapv (partial monthly-columns snapshot-history? end-dt)))
      :last-12-months-monthly (->> (range -11 1)
                                   (mapv (partial monthly-columns snapshot-history? end-dt)))
      :YTD-monthly (->> (range (- end-month) 1)
                        (mapv (partial monthly-columns snapshot-history? end-dt)))
      :YTD-monthly-previous-year-quarterly (concat
                                            (->> (range (- 0 end-month 12) (- end-month))
                                                 (mapv (partial quarterly-columns snapshot-history? end-dt))
                                                 (distinct)
                                                 (sort-by :start-ts))
                                            (->> (range (- end-month) 1)
                                                 (mapv (partial monthly-columns snapshot-history? end-dt))))
      :YTD-monthly-previous-year-monthly (->> (range (- 0 end-month 12) 1)
                                              (mapv (partial monthly-columns snapshot-history? end-dt)))
      :previous-year-12-months-quarterly (->> (range (- 0 end-month 12) (- end-month))
                                              (mapv (partial quarterly-columns snapshot-history? end-dt))
                                              (distinct)
                                              (sort-by :start-ts))
      :last-12-months-quarterly (->> (range -11 1)
                                     (mapv (partial quarterly-columns snapshot-history? end-dt))
                                     (distinct)
                                     (sort-by :start-ts))
      :YTD-quarterly (->> (range (- end-month) 1)
                          (mapv (partial quarterly-columns snapshot-history? end-dt))
                          (distinct)
                          (sort-by :start-ts))
      :YTD-quarterly-previous-year-quarterly (->> (range (- 0 end-month 12) 1)
                                                  (mapv (partial quarterly-columns snapshot-history? end-dt))
                                                  (distinct)
                                                  (sort-by :start-ts))
      :YTD-quarterly-previous-year-yearly (concat (->> (range (- 0 end-month 12) (- end-month))
                                                       (mapv (partial yearly-columns snapshot-history? end-dt))
                                                       (distinct)
                                                       (sort-by :start-ts))
                                                  (->> (range (- end-month) 1)
                                                       (mapv (partial quarterly-columns snapshot-history? end-dt))
                                                       (distinct)
                                                       (sort-by :start-ts)))
      :YTD-quarterly-previous-2-years-yearly (concat (->> (range (- 0 end-month 24) (- end-month))
                                                          (mapv (partial yearly-columns snapshot-history? end-dt))
                                                          (distinct)
                                                          (sort-by :start-ts))
                                                     (->> (range (- end-month) 1)
                                                          (mapv (partial quarterly-columns snapshot-history? end-dt))
                                                          (distinct)
                                                          (sort-by :start-ts)))
      :last-12-months-half-yearly (->> (range -11 1)
                                       (mapv (partial half-yearly-columns snapshot-history? end-dt))
                                       (distinct)
                                       (sort-by :start-ts))
      :YTD-half-yearly (->> (range (- end-month) 1)
                            (mapv (partial half-yearly-columns snapshot-history? end-dt))
                            (distinct)
                            (sort-by :start-ts))
      :YTD-half-yearly-previous-year-half-yearly (->> (range (- 0 end-month 12) 1)
                                                      (mapv (partial half-yearly-columns snapshot-history? end-dt))
                                                      (distinct)
                                                      (sort-by :start-ts))
      :YTD-half-yearly-previous-year-yearly (concat (->> (range (- 0 end-month 12) (- end-month))
                                                         (mapv (partial yearly-columns snapshot-history? end-dt))
                                                         (distinct)
                                                         (sort-by :start-ts))
                                                    (->> (range (- end-month) 1)
                                                         (mapv (partial half-yearly-columns snapshot-history? end-dt))
                                                         (distinct)
                                                         (sort-by :start-ts)))
      :YTD-half-yearly-previous-2-years-yearly (concat (->> (range (- 0 end-month 24) (- end-month))
                                                            (mapv (partial yearly-columns snapshot-history? end-dt))
                                                            (distinct)
                                                            (sort-by :start-ts))
                                                       (->> (range (- end-month) 1)
                                                            (mapv (partial half-yearly-columns snapshot-history? end-dt))
                                                            (distinct)
                                                            (sort-by :start-ts)))
      :YTD-yearly (->> (range (- end-month) 1)
                       (mapv (partial yearly-columns snapshot-history? end-dt))
                       (distinct)
                       (sort-by :start-ts))
      :YTD-yearly-previous-year-yearly (->> (range (- 0 end-month 12) 1)
                                            (mapv (partial yearly-columns snapshot-history? end-dt))
                                            (distinct)
                                            (sort-by :start-ts))
      :YTD-yearly-previous-2-years-yearly (->> (range (- 0 end-month 24) 1)
                                               (mapv (partial yearly-columns snapshot-history? end-dt))
                                               (distinct)
                                               (sort-by :start-ts))
      :custom-range-talk-to-support (->> (range 0 1)
                                         (mapv (partial monthly-columns snapshot-history? end-dt))))))

(defn forecast-columns
  [{:keys [forecast snapshot-forecast? _forecast-in-use? reference-period]}]
  (let [{:keys [end-ts]} reference-period
        end-dt (c-date/date-time end-ts)
        end-month (c-date/get-month end-dt)
        months-until-end-of-year (- 11 end-month)
        next-dt (c-date/plus end-dt (c-date/days 1))]
    (case forecast
      ;; --- To end of current year ---
      :ref-date-til-end-of-year-monthly
      (->> (range 0 months-until-end-of-year)
           (mapv (partial monthly-columns snapshot-forecast? next-dt)))

      :ref-date-til-end-of-year-quarterly
      (->> (range 0 months-until-end-of-year)
           (mapv (partial quarterly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-til-end-of-year-half-yearly
      (->> (range 0 months-until-end-of-year)
           (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-til-end-of-year-half-yearly-next-year-monthly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial monthly-columns snapshot-forecast? next-dt))))

      :ref-date-til-end-of-year-half-yearly-next-year-quarterly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-half-yearly-next-year-half-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-half-yearly-next-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-half-yearly-next-year-monthly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial monthly-columns snapshot-forecast? next-dt)))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-half-yearly-next-year-quarterly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-half-yearly-next-year-half-yearly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-half-yearly-next-year-yearly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      ;; --- To end of year + next year (various granularities) ---
      :ref-date-til-end-of-year-monthly-next-year-monthly
      (->> (range 0 (+ months-until-end-of-year 12))
           (mapv (partial monthly-columns snapshot-forecast? next-dt)))

      :ref-date-til-end-of-year-monthly-next-year-quarterly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial monthly-columns snapshot-forecast? next-dt)))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-monthly-next-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial monthly-columns snapshot-forecast? next-dt)))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-quarterly-next-year-monthly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial monthly-columns snapshot-forecast? next-dt))))

      :ref-date-til-end-of-year-quarterly-next-year-quarterly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-quarterly-next-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      ;; --- To end of year + next year + one more year as yearly ---
      :ref-date-til-end-of-year-monthly-next-year-monthly-1-year-yearly
      (concat
       (->> (range 0 (+ months-until-end-of-year 12))
            (mapv (partial monthly-columns snapshot-forecast? next-dt)))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-monthly-next-year-quarterly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial monthly-columns snapshot-forecast? next-dt)))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-monthly-next-year-yearly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial monthly-columns snapshot-forecast? next-dt)))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-quarterly-next-year-monthly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial monthly-columns snapshot-forecast? next-dt)))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-quarterly-next-year-quarterly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      :ref-date-til-end-of-year-quarterly-next-year-yearly-1-year-yearly
      (concat
       (->> (range 0 months-until-end-of-year)
            (mapv (partial quarterly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range months-until-end-of-year (+ months-until-end-of-year 12))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (+ months-until-end-of-year 12)
                   (+ months-until-end-of-year 24))
            (mapv (partial yearly-columns snapshot-forecast? next-dt))
            (distinct)
            (sort-by :start-ts)))

      ;; --- Rolling windows ---
      :ref-date-rolling-1-month-monthly
      (->> (range 0 1)
           (mapv (partial monthly-columns snapshot-forecast? next-dt)))

      :ref-date-rolling-3-months-monthly
      (->> (range 0 3)
           (mapv (partial monthly-columns snapshot-forecast? next-dt)))

      :ref-date-rolling-6-months-monthly
      (->> (range 0 6)
           (mapv (partial monthly-columns snapshot-forecast? next-dt)))

      :ref-date-rolling-9-months-monthly
      (->> (range 0 9)
           (mapv (partial monthly-columns snapshot-forecast? next-dt)))

      :ref-date-rolling-12-months-monthly
      (->> (range 0 12)
           (mapv (partial monthly-columns snapshot-forecast? next-dt)))

      :ref-date-rolling-3-months-quarterly
      (->> (range 0 3)
           (mapv (partial quarterly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-6-months-quarterly
      (->> (range 0 6)
           (mapv (partial quarterly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-9-months-quarterly
      (->> (range 0 9)
           (mapv (partial quarterly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-12-months-quarterly
      (->> (range 0 12)
           (mapv (partial quarterly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-24-months-quarterly
      (->> (range 0 24)
           (mapv (partial quarterly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-36-months-quarterly
      (->> (range 0 36)
           (mapv (partial quarterly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-6-months-half-yearly
      (->> (range 0 6)
           (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-12-months-half-yearly
      (->> (range 0 12)
           (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-24-months-half-yearly
      (->> (range 0 24)
           (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      :ref-date-rolling-36-months-half-yearly
      (->> (range 0 36)
           (mapv (partial half-yearly-columns snapshot-forecast? next-dt))
           (distinct)
           (sort-by :start-ts))

      ;; --- Full calendar year including ref-date (this year) + optional next year ---
      :full-calendar-year-including-ref-date-monthly
      (->> (range (- end-month) (- 12 end-month))
           (mapv (partial monthly-columns snapshot-forecast? end-dt)))

      :full-calendar-year-including-ref-date-quarterly
      (->> (range (- end-month) (- 12 end-month))
           (mapv (partial quarterly-columns snapshot-forecast? end-dt))
           (distinct)
           (sort-by :start-ts))

      :full-calendar-year-including-ref-date-half-yearly
      (->> (range (- end-month) (- 12 end-month))
           (mapv (partial half-yearly-columns snapshot-forecast? end-dt))
           (distinct)
           (sort-by :start-ts))

      :full-calendar-year-including-ref-date-half-yearly-1-year-monthly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial half-yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial monthly-columns snapshot-forecast? end-dt))))

      :full-calendar-year-including-ref-date-half-yearly-1-year-quarterly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial half-yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial quarterly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts)))

      :full-calendar-year-including-ref-date-half-yearly-1-year-half-yearly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial half-yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial half-yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts)))

      :full-calendar-year-including-ref-date-half-yearly-1-year-yearly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial half-yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts)))

      :full-calendar-year-including-ref-date-yearly
      (->> (range (- end-month) (- 12 end-month))
           (mapv (partial yearly-columns snapshot-forecast? end-dt))
           (distinct)
           (sort-by :start-ts))

      :full-calendar-year-including-ref-date-monthly-1-year-monthly
      (->> (range (- end-month) (- 24 end-month))
           (mapv (partial monthly-columns snapshot-forecast? end-dt)))

      :full-calendar-year-including-ref-date-monthly-1-year-quarterly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial monthly-columns snapshot-forecast? end-dt)))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial quarterly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts)))

      :full-calendar-year-including-ref-date-monthly-1-year-yearly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial monthly-columns snapshot-forecast? end-dt)))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts)))

      :full-calendar-year-including-ref-date-quarterly-1-year-monthly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial quarterly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial monthly-columns snapshot-forecast? end-dt))))

      :full-calendar-year-including-ref-date-quarterly-1-year-quarterly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial quarterly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial quarterly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts)))

      :full-calendar-year-including-ref-date-quarterly-1-year-yearly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial quarterly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts)))

      :full-calendar-year-including-ref-date-yearly-1-year-monthly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial monthly-columns snapshot-forecast? end-dt))))

      :full-calendar-year-including-ref-date-yearly-1-year-quarterly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial quarterly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts)))

      :full-calendar-year-including-ref-date-yearly-1-year-yearly
      (concat
       (->> (range (- end-month) (- 12 end-month))
            (mapv (partial yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))
       (->> (range (- 12 end-month) (- 24 end-month))
            (mapv (partial yearly-columns snapshot-forecast? end-dt))
            (distinct)
            (sort-by :start-ts))))))

(defn table-columns
  "Period columns of a table block, history first. The block must carry a
  `:reference-period` with both `:start-ts` and `:end-ts`."
  [{:keys [history-in-use? forecast-in-use?] :as block}]
  (vec (concat (when history-in-use?
                 (history-columns block))
               (when forecast-in-use?
                 (forecast-columns block)))))

(def forecast-options-ref-date-end-of-year
  [:ref-date-til-end-of-year-monthly
   :ref-date-til-end-of-year-quarterly
   :ref-date-til-end-of-year-half-yearly
   :ref-date-til-end-of-year-monthly-next-year-monthly
   :ref-date-til-end-of-year-monthly-next-year-quarterly
   :ref-date-til-end-of-year-monthly-next-year-yearly
   :ref-date-til-end-of-year-quarterly-next-year-monthly
   :ref-date-til-end-of-year-quarterly-next-year-quarterly
   :ref-date-til-end-of-year-quarterly-next-year-yearly
   :ref-date-til-end-of-year-half-yearly-next-year-monthly
   :ref-date-til-end-of-year-half-yearly-next-year-quarterly
   :ref-date-til-end-of-year-half-yearly-next-year-half-yearly
   :ref-date-til-end-of-year-half-yearly-next-year-yearly
   :ref-date-til-end-of-year-monthly-next-year-monthly-1-year-yearly
   :ref-date-til-end-of-year-monthly-next-year-quarterly-1-year-yearly
   :ref-date-til-end-of-year-monthly-next-year-yearly-1-year-yearly
   :ref-date-til-end-of-year-quarterly-next-year-monthly-1-year-yearly
   :ref-date-til-end-of-year-quarterly-next-year-quarterly-1-year-yearly
   :ref-date-til-end-of-year-quarterly-next-year-yearly-1-year-yearly
   :ref-date-til-end-of-year-half-yearly-next-year-monthly-1-year-yearly
   :ref-date-til-end-of-year-half-yearly-next-year-quarterly-1-year-yearly
   :ref-date-til-end-of-year-half-yearly-next-year-half-yearly-1-year-yearly
   :ref-date-til-end-of-year-half-yearly-next-year-yearly-1-year-yearly])

(def forecast-options-rolling
  [:ref-date-rolling-1-month-monthly
   :ref-date-rolling-3-months-monthly
   :ref-date-rolling-6-months-monthly
   :ref-date-rolling-9-months-monthly
   :ref-date-rolling-12-months-monthly
   :ref-date-rolling-3-months-quarterly
   :ref-date-rolling-6-months-quarterly
   :ref-date-rolling-9-months-quarterly
   :ref-date-rolling-12-months-quarterly
   :ref-date-rolling-24-months-quarterly
   :ref-date-rolling-36-months-quarterly
   :ref-date-rolling-6-months-half-yearly
   :ref-date-rolling-12-months-half-yearly
   :ref-date-rolling-24-months-half-yearly
   :ref-date-rolling-36-months-half-yearly])

(def forecast-options-full-calendar-year
  [:full-calendar-year-including-ref-date-monthly
   :full-calendar-year-including-ref-date-quarterly
   :full-calendar-year-including-ref-date-half-yearly
   :full-calendar-year-including-ref-date-yearly
   :full-calendar-year-including-ref-date-monthly-1-year-monthly
   :full-calendar-year-including-ref-date-monthly-1-year-quarterly
   :full-calendar-year-including-ref-date-monthly-1-year-yearly
   :full-calendar-year-including-ref-date-quarterly-1-year-monthly
   :full-calendar-year-including-ref-date-quarterly-1-year-quarterly
   :full-calendar-year-including-ref-date-quarterly-1-year-yearly
   :full-calendar-year-including-ref-date-half-yearly-1-year-monthly
   :full-calendar-year-including-ref-date-half-yearly-1-year-quarterly
   :full-calendar-year-including-ref-date-half-yearly-1-year-half-yearly
   :full-calendar-year-including-ref-date-half-yearly-1-year-yearly
   :full-calendar-year-including-ref-date-yearly-1-year-monthly
   :full-calendar-year-including-ref-date-yearly-1-year-quarterly
   :full-calendar-year-including-ref-date-yearly-1-year-yearly])
